import { render, staticRenderFns } from "./TopKeywordEditor.vue?vue&type=template&id=5b69f0b4&lang=html"
import script from "./TopKeywordEditor.vue?vue&type=script&lang=js"
export * from "./TopKeywordEditor.vue?vue&type=script&lang=js"
import style0 from "./TopKeywordEditor.vue?vue&type=style&index=0&id=5b69f0b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports